import React from 'react';
import cx from 'classnames';
import { useTranslations } from '@unisporkal/localization';
import styles from '../Messages.module.scss';

const PaPreviewMessage = () => {
  const t = useTranslations();

  return (
    <section className={cx(styles.messages, styles.paPreviewMessage)}>
      <div className={styles.warningMessage}>{t('pa_preview_message')}</div>
    </section>
  );
};

export default PaPreviewMessage;
